export function PlaneIcon(props) {
  const { ...imgAttrs } = props;

  return (
    <img 
      {...imgAttrs}
      className={`profile-icon profile-icon__plane ${imgAttrs.className ? imgAttrs.className : ""}`} 
      src={"https://wvusstatic.com/illustrations/plane.svg?no-cache=true"} 
    />
  )
}

export default PlaneIcon;